// ABOUTME: Utility functions for deriving heart calendar data from DailyProgress records
// ABOUTME: Client-side classification of heart and mending-heart dates from progress history

import type { DailyProgress } from '../types/api';

/**
 * Derives heartDates and mendingHeartDates from an array of DailyProgress records.
 * - mendingHeart: earned a heart AND had both squares AND MakeItRights that day
 * - heartDate: earned a heart and is not a mending heart
 */
export function deriveHeartDates(progress: DailyProgress[]): {
  heartDates: string[];
  mendingHeartDates: string[];
} {
  const heartDates: string[] = [];
  const mendingHeartDates: string[] = [];

  for (const dp of progress) {
    if (!dp.earnedHeart) continue;
    const isMending = dp.squareCount > 0 && dp.makeItRightCount > 0;
    if (isMending) {
      mendingHeartDates.push(dp.date);
    } else {
      heartDates.push(dp.date);
    }
  }

  return { heartDates, mendingHeartDates };
}
